import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=01b7e05e&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b7e05e')) {
      api.createRecord('01b7e05e', component.options)
    } else {
      api.reload('01b7e05e', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=01b7e05e&", function () {
      api.rerender('01b7e05e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2d0yVuWTcoKnt/JS/comp/ImgFallback.vue"
export default component.exports